import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            ihNodeContainer: {
                display: 'flex',
                flexDirection: 'column',
                marginTop: theme.spacing(2),
                padding: theme.spacing(0, 2, 0, 2),
                fontSize: 'small',
                alignItems: 'center',
                justifyContent: 'center',
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: '4px',
            },
            ihNodesSummary: {
                display: 'flex',
                flexDirection: 'column',
            },
            updating: {
                opacity: '.2',
                pointerEvents: 'none',
                filter: 'blur(4px)',
            },
            updatingInfo: {
                position: 'absolute',
                marginTop: theme.spacing(8),
            },
            skeletonContainer: {
                cursor: 'progress',
            },
            errorText: {
                color: theme.palette.error.main,
            },
            tableContainer: {
                width: '100%',
                flexDirection: 'column',
            },
            disabledCheckBox: {
                color: `${theme.palette.success.main} !important`,
                cursor: 'not-allowed',
            },
            pagination: {
                paddingTop: theme.spacing(4),
                display: 'flex',
                justifyContent: 'end',
                [theme.breakpoints.only('xs')]: {
                    justifyContent: 'center',
                },
            },
            noChildrenFoundIcon: {
                marginRight: theme.spacing(2),
                color: theme.palette.indicatorSecondary.main,
                opacity: 0.2,
                cursor: 'not-allowed',
            },
            expansionWrapper: {
                marginRight: theme.spacing(2),
                background: 'none',
                border: 'none',
            },
            expandChildrenIcon: {
                cursor: 'pointer',
            },
            collapseChildrenIcon: {
                cursor: 'pointer',
            },
            loadingChildrenIcon: {
                marginLeft: theme.spacing(4),
            },
            infoTextMargin: {},
            pageSizeComboBox: {
                width: '2rem',
                minWidth: '6rem',
            },
            nodeRow: {
                display: 'flex',
                alignItems: 'center',
            },
            disabledNodeName: {
                color: theme.palette.text.disabled,
                fontStyle: 'italic',
            },
            levelIndicator: {
                fontSize: '0.75rem',
                color: theme.palette.warning.main,
                marginLeft: theme.spacing(1),
                fontWeight: 'normal',
            },
            noContentMessage: {
                margin: theme.spacing(4, 0),
                fontStyle: 'italic',
                color: theme.palette.text.secondary,
                textAlign: 'center',
            },
        }),
    {
        name: 'IHNodes-',
    },
);
